import {NavigationItemConfigType} from '@rdcomponents/app/routing/routing-type';
import {useCallback} from 'react';

import {UserType} from '../user/user-type';

import {AnalyticsDataType, AnalyticsTarget} from './analytics';
import {initializeGoogleAnalytics, trackNavigationGoogleAnalytics} from './analytics-helper';
import {RecursiveValueOfType, UseAnalyticsType} from './analytics-type';

export function useAnalytics(): UseAnalyticsType {
    const initialize = useCallback((user: UserType) => {
        initializeGoogleAnalytics(user);
    }, []);

    const track = useCallback(
        <TKey extends RecursiveValueOfType<typeof AnalyticsTarget>>(
            ...args: TKey extends keyof AnalyticsDataType ? [key: TKey, data: AnalyticsDataType[TKey]] : [key: TKey]
        ) => {
            track(...args);
        },
        []
    );

    const trackNavigation = useCallback(
        (pathname: string, previousPathname: string, navigationConfig: Array<NavigationItemConfigType>) => {
            trackNavigationGoogleAnalytics(pathname, previousPathname, navigationConfig);
        },
        []
    );

    return {initialize, trackNavigation, track};
}
